import EditableRichTextField from './EditableRichTextField'
export default EditableRichTextField




// WEBPACK FOOTER //
// ./src/components/EditableRichTextField/index.js